import social from '../data/social';

// Outline icons (Feather, MIT) to match the site's Heroicons outline style.
export const InstagramIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
  </svg>
);

export const FacebookIcon = ({ className = 'w-5 h-5' }) => (
  <svg className={className} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
  </svg>
);

// Only platforms that have a URL configured in src/data/social.js
export const socialAccounts = [
  social.instagram.url && {
    key: 'instagram',
    label: 'Instagram',
    url: social.instagram.url,
    handle: social.instagram.handle,
    Icon: InstagramIcon
  },
  social.facebook.url && {
    key: 'facebook',
    label: 'Facebook',
    url: social.facebook.url,
    handle: social.facebook.name,
    Icon: FacebookIcon
  }
].filter(Boolean);
